import { useState, useCallback, useEffect } from 'react';

export function useWakeLock() {
    const [wakeLock, setWakeLock] = useState(null);
    const [isRequested, setIsRequested] = useState(false);

    const requestWakeLock = useCallback(async () => {
        if ('wakeLock' in navigator) {
            try {
                const lock = await navigator.wakeLock.request('screen');
                lock.addEventListener('release', () => {
                    setWakeLock(null);
                });
                setWakeLock(lock);
                setIsRequested(true);
                return true;
            } catch (err) {
                console.error('Wake Lock Erro:', err);
                return false;
            }
        }
        return false;
    }, []);

    const releaseWakeLock = useCallback(async () => {
        setIsRequested(false);
        if (wakeLock) {
            try {
                await wakeLock.release();
            } catch (err) {
                console.error('Erro ao liberar Wake Lock:', err);
            }
            setWakeLock(null);
        }
    }, [wakeLock]);

    // Lidar com a mudança de visibilidade para readquirir o lock se o usuário sair e voltar pro app
    useEffect(() => {
        const handleVisibilityChange = async () => {
            if (isRequested && document.visibilityState === 'visible' && !wakeLock) {
                try {
                    const lock = await navigator.wakeLock.request('screen');
                    lock.addEventListener('release', () => {
                        setWakeLock(null);
                    });
                    setWakeLock(lock);
                } catch (err) {
                    console.error('Erro ao re-adquirir Wake Lock:', err);
                }
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [isRequested, wakeLock]);

    // Limpeza ao desmontar
    useEffect(() => {
        return () => {
            if (wakeLock) {
                wakeLock.release().catch(() => { });
            }
        };
    }, [wakeLock]);

    return { requestWakeLock, releaseWakeLock, hasWakeLock: isRequested };
}
